








































































































































import {Vue, Prop, Component} from 'vue-property-decorator';
import { noAbc, nextInput } from "@/modules/budget/monitoring/input-forms/common/formaters"

@Component({
    filters: {
        totalCBC(value: any[]) {
            let sum = 0;
            if (value) {
                for (const gr of value) {
                    for (const r of gr.children) {
                        sum += r.value
                    }
                }
            }
            return parseFloat(Math.abs(sum).toFixed(3));
        }
    }
})
export default class app9ReasonInput extends Vue {
    @Prop({
        required: true,
        default: []
    })
    private reasonsFull!:any[];

    private reasonsTreePl:any[] = [];
    private reasonsTreeOB:any[] = [];

    @Prop({
        required: true,
        default: []
    })
    private cbcList!:any[];
    @Prop({
        required: true,
        default: ''
    })
    private reasonKey1!:string;
    @Prop({
        required: true,
        default: ''
    })
    private reasonKey2!:string;
    @Prop({
        required: true,
        default: ''
    })
    private inputType!:number;

    private get sortedCbcList() {
        return this.cbcList.sort((a:any, b:any) => a['ppr_key'].localeCompare(b['ppr_key']));
    }
    private currentCBC:any = null;
    private created () {
        const that = this;
        this.$watch('currentCBC', (n, o) => {
            if (o !== null) {
                if (o.chagedReasons) {
                    that.onSave(o)
                }
            }
            if (this.currentCBC) {
                const reasonsFullPL:any[] = that.reasonsFull.map((r) => ({...r}))
                const reasonsFullOB:any[] = that.reasonsFull.map((r) => ({...r}))
                for (const r of reasonsFullOB) {
                    if (r.id in that.currentCBC[that.reasonKey1]) {
                        r.value = Math.abs(that.currentCBC[that.reasonKey1][r.id])
                    } else {
                        r.value = 0
                    }
                }
                for (const r of reasonsFullPL) {
                    if (r.id in that.currentCBC[that.reasonKey2]) {
                        r.value = Math.abs(that.currentCBC[that.reasonKey2][r.id])
                    } else {
                        r.value = 0
                    }
                }
                that.reasonsTreeOB = that.createReasonsTreeFlat(null, 1 + (that.inputType - 1) * 2, reasonsFullOB)
                that.reasonsTreePl = that.createReasonsTreeFlat(null, 2 + (that.inputType - 1) * 2, reasonsFullPL)
            }
        })
        if (this.cbcList.length > 0) {
            this.currentCBC = this.sortedCbcList[0]
        }
    }


    private createReasonsTreeFlat(type:any = null, obaz_plat:any = 1, reasonsFull:any[] = []) {
        const that = this;
        const dict_ob:any = {}
        const dict_pl:any = {}
        const pl_gr_name = obaz_plat === 2? `gr_pl_name_`: `gr_ob_name_`
        const ob_gr_name = 'gr_ob_name_'
        for (const r of reasonsFull) {
            if ([3, 4].includes(obaz_plat) && ![10, 11].includes(r.gr_ob_id)) {
                continue;
            }
            if (type !== null) {
                if (r.type !== type && r.type !== 3) {
                    continue
                }
            }
            if (!dict_ob[r.gr_ob_id] && [1, 3].includes(obaz_plat)) {
                const grob =  {children: [], open: false, ...r}
                Object.defineProperty(grob, 'label', {
                    get() {
                        return grob[`${ob_gr_name}${that.$i18n.locale}`]
                    }
                })
                Object.defineProperty(grob, 'value', {
                    get: function () {
                        let sum = 0
                        for (const ch of grob.children) {
                            sum += ch.value
                        }
                        return sum
                    }
                })
                if (r.gr_ob_id === 10 || obaz_plat === 1) {
                    dict_ob[r.gr_ob_id] = grob
                }

            }
            const pl_gr_key = obaz_plat === 2? r.gr_pl_id: r.gr_ob_id
            if (!dict_pl[pl_gr_key] && [2, 4].includes(obaz_plat)) {
                const grpl =  {children: [], open: false, ...r}
                Object.defineProperty(grpl, 'label', {
                    get() {
                        return grpl[`${pl_gr_name}${that.$i18n.locale}`]
                    }
                })
                Object.defineProperty(grpl, 'value', {
                    get: function () {
                        let sum = 0
                        for (const ch of grpl.children) {
                            sum += ch.value
                        }
                        return sum
                    }
                })
                if (pl_gr_key === 11 || obaz_plat === 2) {
                    dict_pl[pl_gr_key] = grpl
                }
            }
            if ([1, 3].includes(obaz_plat)) {
                const roob:any = {...r}
                Object.defineProperty(roob, 'label', {
                    get() {
                        return roob[`name_${that.$i18n.locale}`]
                    }
                })
                if (r.gr_ob_id === 10 || obaz_plat === 1) {
                    dict_ob[r.gr_ob_id].children.push(roob)
                }
            }
            if ([2, 4].includes(obaz_plat)) {
                const ropl:any = {...r}
                Object.defineProperty(ropl, 'label', {
                    get() {
                        return ropl[`name_${that.$i18n.locale}`]
                    }
                })
                if (pl_gr_key === 11 || obaz_plat === 2) {
                    dict_pl[pl_gr_key].children.push(ropl)
                }
            }

        }
        if ([1, 3].includes(obaz_plat)) return Object.values(dict_ob)
        else return Object.values(dict_pl)
    }
    private get flk1() {
        if (this.inputType === 2) {
            return false
        }
        return parseFloat(Math.abs(this.currentCBC[this.flk1_key]).toFixed(3)) !== this.totalCBCPL
    }
    private get flk2() {
        if (this.inputType === 2) {
            return false
        }
        return parseFloat(Math.abs(this.currentCBC[this.flk2_key]).toFixed(3)) !== this.totalCBCOB
    }
    private total(value: any[]) {
        let sum = 0;
        if (value) {
            for (const gr of value) {
                for (const r of gr.children) {
                    sum += r.value
                }
            }
        }
        return parseFloat(Math.abs(sum).toFixed(3));
    }
    private get flk1_key():string {
        if (this.inputType === 2) {
            return 'execution_on_not_executed'
        }
        return 'sum_not_executed_payment'
    }
    private get flk2_key():string {
        if (this.inputType === 2) {
            return 'execution_on_not_executed'
        }
        return 'sum_discarded_oblig'
    }
    private get totalCBCOB():number {
        if (this.inputType === 2) {
            return this.totalAll
        }
        return this.total(this.reasonsTreeOB)
    }
    private get totalCBCPL():number {
        if (this.inputType === 2) {
            return this.totalAll
        }
        return this.total(this.reasonsTreePl)
    }

    private get totalAll(): number {
        return this.total([...this.reasonsTreeOB, ...this.reasonsTreePl])
    }

    private onClearReasons() {
        this.$bvModal.msgBoxConfirm(
            this.$t('modules.budget_execution_monitoring.reports.app_9.reason_input.confirm_delete').toString(),
            {
                title: this.$t('modules.budget_execution_monitoring.reports.app_9.confirmation').toString(),
                buttonSize: 'sm',
                okVariant: 'success',
                okTitle: this.$t('modules.budget_execution_monitoring.input_forms.massage_tools.yes').toString(),
                cancelTitle: this.$t('modules.budget_execution_monitoring.input_forms.massage_tools.cancellation').toString(),
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })
            .then(value => {
                if (value) {
                    for (const gr of this.reasonsTreePl) {
                        for (const r of gr.children) {
                            if (r.value !== 0) {
                                r.value = 0
                                this.currentCBC[this.reasonKey2][r.id] = 0
                                this.currentCBC.chagedReasons = true
                            }
                        }
                    }
                    for (const gr of this.reasonsTreeOB) {
                        for (const r of gr.children) {
                            if (r.value !== 0) {
                                r.value = 0
                                this.currentCBC[this.reasonKey1][r.id] = 0
                                this.currentCBC.chagedReasons = true
                            }
                        }
                    }
                }
            })
            .catch(error => {
                this.makeToast('danger', this.$t('modules.budget_execution_monitoring.reports.app_9.save_error'), error.toString());
            });
    }

    private onBack() {
        if (this.currentCBC?.chagedReasons) {
            this.onSave(this.currentCBC);
        }
        this.$emit('onBack')
    }
    private onNext() {
        this.onSave(this.currentCBC)
        const totalCBC = (cbk:any) => {
            let sum = 0;
            for (const r of Object.keys(cbk)) {
                sum += cbk[r]
            }
            return parseFloat(Math.abs(sum).toFixed(3));
        }
        const isFlk = (v:any) => {

            if (this.inputType === 2) {
                return false
            }
            const total1 = totalCBC(v[this.reasonKey1]);
            const total2 = totalCBC(v[this.reasonKey2]);
            const flk1 = parseFloat(Math.abs(v[this.flk1_key]).toFixed(3));
            const flk2 = parseFloat(Math.abs(v[this.flk2_key]).toFixed(3));
            return this.inputType === 2
                ? total1 + total2 !== flk1
                : total2 !== flk1 || total1 !== flk2;
        }
        const currentCBCIndex = this.sortedCbcList.findIndex((v:any) => parseInt(v.ppr_key.replace(/\s+/g, '')) === parseInt(this.currentCBC.ppr_key.replace(/\s+/g, '')))
        const success = this.sortedCbcList.every((v: any) => !isFlk(v))
        let newIndex = currentCBCIndex;
        if (this.inputType === 1) {
            newIndex = this.sortedCbcList.findIndex((v:any) => v.ppr_key > this.currentCBC.ppr_key && isFlk(v))
        } else {
            newIndex += 1
        }

        if (newIndex < 0 || currentCBCIndex >= this.sortedCbcList.length - 1) {
            newIndex = 0;
        }
        this.currentCBC = this.sortedCbcList[newIndex]
        if (success && this.inputType === 1) {
            this.makeToast('success',
                this.$t('modules.budget_execution_monitoring.input_forms.massage_tools.massage'),
                this.$t('modules.budget_execution_monitoring.reports.app_9.reason_input.warn_success_reasons')
            )
        }
    }

    private onSave(currentCBC:any = null) {
        if (currentCBC === null) {
            currentCBC = this.currentCBC
        }
        currentCBC[this.reasonKey2] = {}
        currentCBC[this.reasonKey1] = {}
        for (const gr of this.reasonsTreePl) {
            for (const r of gr.children) {
                if (r.value !== 0) {
                    currentCBC[this.reasonKey2][r.id] = -Math.abs(r.value)
                }
            }
        }
        for (const gr of this.reasonsTreeOB) {
            for (const r of gr.children) {
                if (r.value !== 0) {
                    currentCBC[this.reasonKey1][r.id] = -Math.abs(r.value)
                }
            }
        }
        if (currentCBC && currentCBC.hasOwnProperty('chagedReasons')) {
            currentCBC.hasChanges = true
            delete currentCBC.chagedReasons;
        }
    }
    private onSaveAndClose() {
        this.onSave(this.currentCBC)
        this.onBack()
    }
    // -----------------
    private noAbc: Function = noAbc
    private nextInput: Function = nextInput

    private getNextInputIndx(prgIdx: number, pprIdx: number, spfIndx: number, chldIndx: number | null) {
    }
    // ---------

    private inputFocus(event: any) {
        event.target.select();
    }
    private onChange(value: any, reasonEl: any) {
        if (value) {
            reasonEl.value = parseFloat(value.toString().replace(/,/g, '.').replace(/ /g, ''))
        } else {
            reasonEl.value = 0;
        }
    }
    private inputFixed(item: any, field: any, value: any, digit: any) {
        this.currentCBC.chagedReasons = true
        if (value) {
            this.$set(item, field, parseFloat(Math.abs(parseFloat(value.toString().replace(/,/g, '.').replace(/ /g, ''))).toFixed(digit)));
        } else {
            this.$set(item, field, 0);
        }
    }

    private makeToast(variant: any, title: any, tostbody: any) {
        this.$bvToast.toast(tostbody, {
            title: title,
            variant: variant,
            toaster: 'b-toaster-top-center',
            autoHideDelay: 5000,
            appendToast: true
        });
    }
}
